const baiduRegion = [
        {
                "title": "北京",
                "value": 1000,
                "key": 1000,
                "children": [
                        {
                                "title": "北京",
                                "value": 1000,
                                "key": 1000
                        }
                ]
        },
        {
                "title": "上海",
                "value": 2000,
                "key": 2000,
                "children": [
                        {
                                "title": "上海",
                                "value": 2000,
                                "key": 2000
                        }
                ]
        },
        {
                "title": "天津",
                "value": 3000,
                "key": 3000,
                "children": [
                        {
                                "title": "天津",
                                "value": 3000,
                                "key": 3000
                        }
                ]
        },
        {
                "title": "广东",
                "value": 4000,
                "key": 4000,
                "children": [
                        {
                                "title": "阳江",
                                "value": 4109,
                                "key": 4109
                        },
                        {
                                "title": "湛江",
                                "value": 4110,
                                "key": 4110
                        },
                        {
                                "title": "云浮",
                                "value": 4111,
                                "key": 4111
                        },
                        {
                                "title": "中山",
                                "value": 4112,
                                "key": 4112
                        },
                        {
                                "title": "珠海",
                                "value": 4113,
                                "key": 4113
                        },
                        {
                                "title": "肇庆",
                                "value": 4114,
                                "key": 4114
                        },
                        {
                                "title": "河源",
                                "value": 4115,
                                "key": 4115
                        },
                        {
                                "title": "东莞",
                                "value": 4116,
                                "key": 4116
                        },
                        {
                                "title": "惠州",
                                "value": 4117,
                                "key": 4117
                        },
                        {
                                "title": "江门",
                                "value": 4082,
                                "key": 4082
                        },
                        {
                                "title": "揭阳",
                                "value": 4083,
                                "key": 4083
                        },
                        {
                                "title": "广州",
                                "value": 4084,
                                "key": 4084
                        },
                        {
                                "title": "潮州",
                                "value": 4085,
                                "key": 4085
                        },
                        {
                                "title": "茂名",
                                "value": 4086,
                                "key": 4086
                        },
                        {
                                "title": "梅州",
                                "value": 4088,
                                "key": 4088
                        },
                        {
                                "title": "清远",
                                "value": 4089,
                                "key": 4089
                        },
                        {
                                "title": "佛山",
                                "value": 4090,
                                "key": 4090
                        },
                        {
                                "title": "汕头",
                                "value": 4091,
                                "key": 4091
                        },
                        {
                                "title": "汕尾",
                                "value": 4092,
                                "key": 4092
                        },
                        {
                                "title": "深圳",
                                "value": 4093,
                                "key": 4093
                        },
                        {
                                "title": "韶关",
                                "value": 4094,
                                "key": 4094
                        }
                ]
        },
        {
                "title": "福建",
                "value": 5000,
                "key": 5000,
                "children": [
                        {
                                "title": "莆田",
                                "value": 5048,
                                "key": 5048
                        },
                        {
                                "title": "南平",
                                "value": 5049,
                                "key": 5049
                        },
                        {
                                "title": "龙岩",
                                "value": 5050,
                                "key": 5050
                        },
                        {
                                "title": "宁德",
                                "value": 5051,
                                "key": 5051
                        },
                        {
                                "title": "泉州",
                                "value": 5052,
                                "key": 5052
                        },
                        {
                                "title": "三明",
                                "value": 5066,
                                "key": 5066
                        },
                        {
                                "title": "厦门",
                                "value": 5070,
                                "key": 5070
                        },
                        {
                                "title": "漳州",
                                "value": 5080,
                                "key": 5080
                        },
                        {
                                "title": "福州",
                                "value": 5081,
                                "key": 5081
                        }
                ]
        },
        {
                "title": "海南",
                "value": 8000,
                "key": 8000,
                "children": [
                        {
                                "title": "东方",
                                "value": 8296,
                                "key": 8296
                        },
                        {
                                "title": "琼海",
                                "value": 8297,
                                "key": 8297
                        },
                        {
                                "title": "三亚",
                                "value": 8298,
                                "key": 8298
                        },
                        {
                                "title": "文昌",
                                "value": 8299,
                                "key": 8299
                        },
                        {
                                "title": "五指山",
                                "value": 8300,
                                "key": 8300
                        },
                        {
                                "title": "万宁",
                                "value": 8301,
                                "key": 8301
                        },
                        {
                                "title": "海口",
                                "value": 8302,
                                "key": 8302
                        },
                        {
                                "title": "儋州",
                                "value": 8303,
                                "key": 8303
                        },
                        {
                                "title": "定安",
                                "value": 8484,
                                "key": 8484
                        },
                        {
                                "title": "屯昌",
                                "value": 8485,
                                "key": 8485
                        },
                        {
                                "title": "陵水",
                                "value": 8486,
                                "key": 8486
                        },
                        {
                                "title": "澄迈",
                                "value": 8487,
                                "key": 8487
                        },
                        {
                                "title": "保亭",
                                "value": 8488,
                                "key": 8488
                        },
                        {
                                "title": "琼中",
                                "value": 8489,
                                "key": 8489
                        },
                        {
                                "title": "乐东",
                                "value": 8490,
                                "key": 8490
                        },
                        {
                                "title": "临高",
                                "value": 8491,
                                "key": 8491
                        },
                        {
                                "title": "昌江",
                                "value": 8492,
                                "key": 8492
                        },
                        {
                                "title": "白沙",
                                "value": 8493,
                                "key": 8493
                        },
                        {
                                "title": "三沙",
                                "value": 8521,
                                "key": 8521
                        }
                ]
        },
        {
                "title": "安徽",
                "value": 9000,
                "key": 9000,
                "children": [
                        {
                                "title": "淮北",
                                "value": 9127,
                                "key": 9127
                        },
                        {
                                "title": "安庆",
                                "value": 9128,
                                "key": 9128
                        },
                        {
                                "title": "池州",
                                "value": 9130,
                                "key": 9130
                        },
                        {
                                "title": "滁州",
                                "value": 9131,
                                "key": 9131
                        },
                        {
                                "title": "黄山",
                                "value": 9132,
                                "key": 9132
                        },
                        {
                                "title": "池南",
                                "value": 9133,
                                "key": 9133
                        },
                        {
                                "title": "马鞍山",
                                "value": 9134,
                                "key": 9134
                        },
                        {
                                "title": "六安",
                                "value": 9135,
                                "key": 9135
                        },
                        {
                                "title": "宣城",
                                "value": 9136,
                                "key": 9136
                        },
                        {
                                "title": "宿州",
                                "value": 9137,
                                "key": 9137
                        },
                        {
                                "title": "铜陵",
                                "value": 9138,
                                "key": 9138
                        },
                        {
                                "title": "芜湖",
                                "value": 9139,
                                "key": 9139
                        },
                        {
                                "title": "阜阳",
                                "value": 9140,
                                "key": 9140
                        },
                        {
                                "title": "蚌埠",
                                "value": 9141,
                                "key": 9141
                        },
                        {
                                "title": "合肥",
                                "value": 9142,
                                "key": 9142
                        },
                        {
                                "title": "毫州",
                                "value": 9143,
                                "key": 9143
                        }
                ]
        },
        {
                "title": "贵州",
                "value": 10000,
                "key": 10000,
                "children": [
                        {
                                "title": "贵阳",
                                "value": 10118,
                                "key": 10118
                        },
                        {
                                "title": "安顺",
                                "value": 10119,
                                "key": 10119
                        },
                        {
                                "title": "六盘水",
                                "value": 10120,
                                "key": 10120
                        },
                        {
                                "title": "黔南",
                                "value": 10121,
                                "key": 10121
                        },
                        {
                                "title": "黔东南",
                                "value": 10122,
                                "key": 10122
                        },
                        {
                                "title": "黔西南",
                                "value": 10123,
                                "key": 10123
                        },
                        {
                                "title": "毕节",
                                "value": 10124,
                                "key": 10124
                        },
                        {
                                "title": "铜仁",
                                "value": 10125,
                                "key": 10125
                        },
                        {
                                "title": "遵义",
                                "value": 10126,
                                "key": 10126
                        }
                ]
        },
        {
                "title": "甘肃",
                "value": 11000,
                "key": 11000,
                "children": [
                        {
                                "title": "酒泉",
                                "value": 11255,
                                "key": 11255
                        },
                        {
                                "title": "金昌",
                                "value": 11256,
                                "key": 11256
                        },
                        {
                                "title": "嘉峪关",
                                "value": 11257,
                                "key": 11257
                        },
                        {
                                "title": "兰州",
                                "value": 11258,
                                "key": 11258
                        },
                        {
                                "title": "陇南",
                                "value": 11259,
                                "key": 11259
                        },
                        {
                                "title": "平凉",
                                "value": 11260,
                                "key": 11260
                        },
                        {
                                "title": "临夏",
                                "value": 11261,
                                "key": 11261
                        },
                        {
                                "title": "庆阳",
                                "value": 11262,
                                "key": 11262
                        },
                        {
                                "title": "定西",
                                "value": 11263,
                                "key": 11263
                        },
                        {
                                "title": "武威",
                                "value": 11264,
                                "key": 11264
                        },
                        {
                                "title": "天水",
                                "value": 11265,
                                "key": 11265
                        },
                        {
                                "title": "张掖",
                                "value": 11266,
                                "key": 11266
                        },
                        {
                                "title": "白银",
                                "value": 11267,
                                "key": 11267
                        },
                        {
                                "title": "甘南",
                                "value": 11477,
                                "key": 11477
                        }
                ]
        },
        {
                "title": "广西",
                "value": 12000,
                "key": 12000,
                "children": [
                        {
                                "title": "来宾",
                                "value": 12100,
                                "key": 12100
                        },
                        {
                                "title": "柳州",
                                "value": 12101,
                                "key": 12101
                        },
                        {
                                "title": "钦州",
                                "value": 12102,
                                "key": 12102
                        },
                        {
                                "title": "梧州",
                                "value": 12103,
                                "key": 12103
                        },
                        {
                                "title": "北海",
                                "value": 12104,
                                "key": 12104
                        },
                        {
                                "title": "玉林",
                                "value": 12105,
                                "key": 12105
                        },
                        {
                                "title": "河池",
                                "value": 12106,
                                "key": 12106
                        },
                        {
                                "title": "贺州",
                                "value": 12107,
                                "key": 12107
                        },
                        {
                                "title": "百色",
                                "value": 12108,
                                "key": 12108
                        },
                        {
                                "title": "崇左",
                                "value": 12478,
                                "key": 12478
                        },
                        {
                                "title": "桂林",
                                "value": 12095,
                                "key": 12095
                        },
                        {
                                "title": "贵港",
                                "value": 12096,
                                "key": 12096
                        },
                        {
                                "title": "防城港",
                                "value": 12098,
                                "key": 12098
                        },
                        {
                                "title": "南宁",
                                "value": 12099,
                                "key": 12099
                        }
                ]
        },
        {
                "title": "河北",
                "value": 13000,
                "key": 13000,
                "children": [
                        {
                                "title": "保定",
                                "value": 13304,
                                "key": 13304
                        },
                        {
                                "title": "沧州",
                                "value": 13305,
                                "key": 13305
                        },
                        {
                                "title": "承德",
                                "value": 13306,
                                "key": 13306
                        },
                        {
                                "title": "廊坊",
                                "value": 13307,
                                "key": 13307
                        },
                        {
                                "title": "秦皇岛",
                                "value": 13325,
                                "key": 13325
                        },
                        {
                                "title": "邢台",
                                "value": 13326,
                                "key": 13326
                        },
                        {
                                "title": "石家庄",
                                "value": 13327,
                                "key": 13327
                        },
                        {
                                "title": "唐山",
                                "value": 13329,
                                "key": 13329
                        },
                        {
                                "title": "邯郸",
                                "value": 13330,
                                "key": 13330
                        },
                        {
                                "title": "张家口",
                                "value": 13331,
                                "key": 13331
                        },
                        {
                                "title": "衡水",
                                "value": 13332,
                                "key": 13332
                        }
                ]
        },
        {
                "title": "河南",
                "value": 14000,
                "key": 14000,
                "children": [
                        {
                                "title": "焦作",
                                "value": 14308,
                                "key": 14308
                        },
                        {
                                "title": "安阳",
                                "value": 14309,
                                "key": 14309
                        },
                        {
                                "title": "开封",
                                "value": 14310,
                                "key": 14310
                        },
                        {
                                "title": "洛阳",
                                "value": 14311,
                                "key": 14311
                        },
                        {
                                "title": "漯河",
                                "value": 14312,
                                "key": 14312
                        },
                        {
                                "title": "平顶山",
                                "value": 14313,
                                "key": 14313
                        },
                        {
                                "title": "驻马店",
                                "value": 14314,
                                "key": 14314
                        },
                        {
                                "title": "南阳",
                                "value": 14315,
                                "key": 14315
                        },
                        {
                                "title": "濮阳",
                                "value": 14316,
                                "key": 14316
                        },
                        {
                                "title": "新乡",
                                "value": 14317,
                                "key": 14317
                        },
                        {
                                "title": "信阳",
                                "value": 14318,
                                "key": 14318
                        },
                        {
                                "title": "许昌",
                                "value": 14319,
                                "key": 14319
                        },
                        {
                                "title": "商丘",
                                "value": 14320,
                                "key": 14320
                        },
                        {
                                "title": "三门峡",
                                "value": 14321,
                                "key": 14321
                        },
                        {
                                "title": "郑州",
                                "value": 14322,
                                "key": 14322
                        },
                        {
                                "title": "鹤壁",
                                "value": 14323,
                                "key": 14323
                        },
                        {
                                "title": "周口",
                                "value": 14324,
                                "key": 14324
                        },
                        {
                                "title": "济源",
                                "value": 14476,
                                "key": 14476
                        }
                ]
        },
        {
                "title": "黑龙江",
                "value": 15000,
                "key": 15000,
                "children": [
                        {
                                "title": "鸡西",
                                "value": 15333,
                                "key": 15333
                        },
                        {
                                "title": "佳木斯",
                                "value": 15334,
                                "key": 15334
                        },
                        {
                                "title": "哈尔滨",
                                "value": 15335,
                                "key": 15335
                        },
                        {
                                "title": "牡丹江",
                                "value": 15336,
                                "key": 15336
                        },
                        {
                                "title": "齐齐哈尔",
                                "value": 15337,
                                "key": 15337
                        },
                        {
                                "title": "七台河",
                                "value": 15338,
                                "key": 15338
                        },
                        {
                                "title": "绥化",
                                "value": 15339,
                                "key": 15339
                        },
                        {
                                "title": "双鸭山",
                                "value": 15340,
                                "key": 15340
                        },
                        {
                                "title": "伊春",
                                "value": 15341,
                                "key": 15341
                        },
                        {
                                "title": "大庆",
                                "value": 15342,
                                "key": 15342
                        },
                        {
                                "title": "大兴安岭",
                                "value": 15343,
                                "key": 15343
                        },
                        {
                                "title": "鹤岗",
                                "value": 15344,
                                "key": 15344
                        },
                        {
                                "title": "黑河",
                                "value": 15345,
                                "key": 15345
                        }
                ]
        },
        {
                "title": "湖北",
                "value": 16000,
                "key": 16000,
                "children": [
                        {
                                "title": "荆门",
                                "value": 16346,
                                "key": 16346
                        },
                        {
                                "title": "荆州",
                                "value": 16347,
                                "key": 16347
                        },
                        {
                                "title": "黄石",
                                "value": 16348,
                                "key": 16348
                        },
                        {
                                "title": "黄冈",
                                "value": 16349,
                                "key": 16349
                        },
                        {
                                "title": "潜江",
                                "value": 16364,
                                "key": 16364
                        },
                        {
                                "title": "孝感",
                                "value": 16365,
                                "key": 16365
                        },
                        {
                                "title": "恩施",
                                "value": 16366,
                                "key": 16366
                        },
                        {
                                "title": "随州",
                                "value": 16367,
                                "key": 16367
                        },
                        {
                                "title": "神农架",
                                "value": 16368,
                                "key": 16368
                        },
                        {
                                "title": "十堰",
                                "value": 16369,
                                "key": 16369
                        },
                        {
                                "title": "襄阳",
                                "value": 16370,
                                "key": 16370
                        },
                        {
                                "title": "武汉",
                                "value": 16371,
                                "key": 16371
                        },
                        {
                                "title": "仙桃",
                                "value": 16372,
                                "key": 16372
                        },
                        {
                                "title": "天门",
                                "value": 16373,
                                "key": 16373
                        },
                        {
                                "title": "咸宁",
                                "value": 16375,
                                "key": 16375
                        },
                        {
                                "title": "宜昌",
                                "value": 16376,
                                "key": 16376
                        },
                        {
                                "title": "鄂州",
                                "value": 16377,
                                "key": 16377
                        }
                ]
        },
        {
                "title": "湖南",
                "value": 17000,
                "key": 17000,
                "children": [
                        {
                                "title": "怀化",
                                "value": 17350,
                                "key": 17350
                        },
                        {
                                "title": "常德",
                                "value": 17351,
                                "key": 17351
                        },
                        {
                                "title": "长沙",
                                "value": 17352,
                                "key": 17352
                        },
                        {
                                "title": "郴州",
                                "value": 17353,
                                "key": 17353
                        },
                        {
                                "title": "娄底",
                                "value": 17354,
                                "key": 17354
                        },
                        {
                                "title": "邵阳",
                                "value": 17355,
                                "key": 17355
                        },
                        {
                                "title": "湘潭",
                                "value": 17356,
                                "key": 17356
                        },
                        {
                                "title": "湘西",
                                "value": 17357,
                                "key": 17357
                        },
                        {
                                "title": "张家界",
                                "value": 17358,
                                "key": 17358
                        },
                        {
                                "title": "益阳",
                                "value": 17359,
                                "key": 17359
                        },
                        {
                                "title": "衡阳",
                                "value": 17360,
                                "key": 17360
                        },
                        {
                                "title": "岳阳",
                                "value": 17361,
                                "key": 17361
                        },
                        {
                                "title": "永州",
                                "value": 17362,
                                "key": 17362
                        },
                        {
                                "title": "株洲",
                                "value": 17363,
                                "key": 17363
                        }
                ]
        },
        {
                "title": "吉林",
                "value": 18000,
                "key": 18000,
                "children": [
                        {
                                "title": "吉林",
                                "value": 18038,
                                "key": 18038
                        },
                        {
                                "title": "白城",
                                "value": 18039,
                                "key": 18039
                        },
                        {
                                "title": "长春",
                                "value": 18040,
                                "key": 18040
                        },
                        {
                                "title": "辽源",
                                "value": 18041,
                                "key": 18041
                        },
                        {
                                "title": "白山",
                                "value": 18042,
                                "key": 18042
                        },
                        {
                                "title": "四平",
                                "value": 18043,
                                "key": 18043
                        },
                        {
                                "title": "松原",
                                "value": 18044,
                                "key": 18044
                        },
                        {
                                "title": "通化",
                                "value": 18045,
                                "key": 18045
                        },
                        {
                                "title": "延边",
                                "value": 18047,
                                "key": 18047
                        }
                ]
        },
        {
                "title": "江苏",
                "value": 19000,
                "key": 19000,
                "children": [
                        {
                                "title": "淮安",
                                "value": 19053,
                                "key": 19053
                        },
                        {
                                "title": "常州",
                                "value": 19054,
                                "key": 19054
                        },
                        {
                                "title": "南京",
                                "value": 19055,
                                "key": 19055
                        },
                        {
                                "title": "南通",
                                "value": 19056,
                                "key": 19056
                        },
                        {
                                "title": "连云港",
                                "value": 19057,
                                "key": 19057
                        },
                        {
                                "title": "徐州",
                                "value": 19058,
                                "key": 19058
                        },
                        {
                                "title": "苏州",
                                "value": 19059,
                                "key": 19059
                        },
                        {
                                "title": "宿迁",
                                "value": 19060,
                                "key": 19060
                        },
                        {
                                "title": "泰州",
                                "value": 19061,
                                "key": 19061
                        },
                        {
                                "title": "无锡",
                                "value": 19062,
                                "key": 19062
                        },
                        {
                                "title": "盐城",
                                "value": 19063,
                                "key": 19063
                        },
                        {
                                "title": "扬州",
                                "value": 19064,
                                "key": 19064
                        },
                        {
                                "title": "镇江",
                                "value": 19065,
                                "key": 19065
                        }
                ]
        },
        {
                "title": "江西",
                "value": 20000,
                "key": 20000,
                "children": [
                        {
                                "title": "九江",
                                "value": 20067,
                                "key": 20067
                        },
                        {
                                "title": "吉安",
                                "value": 20068,
                                "key": 20068
                        },
                        {
                                "title": "景德镇",
                                "value": 20069,
                                "key": 20069
                        },
                        {
                                "title": "萍乡",
                                "value": 20071,
                                "key": 20071
                        },
                        {
                                "title": "南昌",
                                "value": 20072,
                                "key": 20072
                        },
                        {
                                "title": "新余",
                                "value": 20073,
                                "key": 20073
                        },
                        {
                                "title": "上饶",
                                "value": 20074,
                                "key": 20074
                        },
                        {
                                "title": "宜春",
                                "value": 20075,
                                "key": 20075
                        },
                        {
                                "title": "鹰潭",
                                "value": 20076,
                                "key": 20076
                        },
                        {
                                "title": "赣州",
                                "value": 20077,
                                "key": 20077
                        },
                        {
                                "title": "抚州",
                                "value": 20078,
                                "key": 20078
                        }
                ]
        },
        {
                "title": "辽宁",
                "value": 21000,
                "key": 21000,
                "children": [
                        {
                                "title": "丹东",
                                "value": 21144,
                                "key": 21144
                        },
                        {
                                "title": "本溪",
                                "value": 21145,
                                "key": 21145
                        },
                        {
                                "title": "锦州",
                                "value": 21146,
                                "key": 21146
                        },
                        {
                                "title": "朝阳",
                                "value": 21147,
                                "key": 21147
                        },
                        {
                                "title": "辽阳",
                                "value": 21148,
                                "key": 21148
                        },
                        {
                                "title": "盘锦",
                                "value": 21149,
                                "key": 21149
                        },
                        {
                                "title": "阜新",
                                "value": 21150,
                                "key": 21150
                        },
                        {
                                "title": "鞍山",
                                "value": 21151,
                                "key": 21151
                        },
                        {
                                "title": "抚顺",
                                "value": 21152,
                                "key": 21152
                        },
                        {
                                "title": "沈阳",
                                "value": 21153,
                                "key": 21153
                        },
                        {
                                "title": "铁岭",
                                "value": 21154,
                                "key": 21154
                        },
                        {
                                "title": "大连",
                                "value": 21155,
                                "key": 21155
                        },
                        {
                                "title": "营口",
                                "value": 21156,
                                "key": 21156
                        },
                        {
                                "title": "葫芦岛",
                                "value": 21157,
                                "key": 21157
                        }
                ]
        },
        {
                "title": "内蒙古",
                "value": 22000,
                "key": 22000,
                "children": [
                        {
                                "title": "赤峰",
                                "value": 22158,
                                "key": 22158
                        },
                        {
                                "title": "阿拉善盟",
                                "value": 22159,
                                "key": 22159
                        },
                        {
                                "title": "兴安盟",
                                "value": 22160,
                                "key": 22160
                        },
                        {
                                "title": "通辽",
                                "value": 22161,
                                "key": 22161
                        },
                        {
                                "title": "巴彦淖尔",
                                "value": 22162,
                                "key": 22162
                        },
                        {
                                "title": "乌兰察布",
                                "value": 22163,
                                "key": 22163
                        },
                        {
                                "title": "乌海",
                                "value": 22164,
                                "key": 22164
                        },
                        {
                                "title": "锡林郭勒盟",
                                "value": 22165,
                                "key": 22165
                        },
                        {
                                "title": "呼伦贝尔",
                                "value": 22166,
                                "key": 22166
                        },
                        {
                                "title": "呼和浩特",
                                "value": 22167,
                                "key": 22167
                        },
                        {
                                "title": "鄂尔多斯",
                                "value": 22168,
                                "key": 22168
                        },
                        {
                                "title": "包头",
                                "value": 22169,
                                "key": 22169
                        }
                ]
        },
        {
                "title": "宁夏",
                "value": 23000,
                "key": 23000,
                "children": [
                        {
                                "title": "固原",
                                "value": 23170,
                                "key": 23170
                        },
                        {
                                "title": "石嘴山",
                                "value": 23171,
                                "key": 23171
                        },
                        {
                                "title": "吴忠",
                                "value": 23172,
                                "key": 23172
                        },
                        {
                                "title": "中卫",
                                "value": 23173,
                                "key": 23173
                        },
                        {
                                "title": "银川",
                                "value": 23174,
                                "key": 23174
                        }
                ]
        },
        {
                "title": "青海",
                "value": 24000,
                "key": 24000,
                "children": [
                        {
                                "title": "西宁",
                                "value": 24175,
                                "key": 24175
                        },
                        {
                                "title": "海东",
                                "value": 24176,
                                "key": 24176
                        },
                        {
                                "title": "海西",
                                "value": 24177,
                                "key": 24177
                        },
                        {
                                "title": "玉树",
                                "value": 24178,
                                "key": 24178
                        },
                        {
                                "title": "海南",
                                "value": 24479,
                                "key": 24479
                        },
                        {
                                "title": "海北",
                                "value": 24494,
                                "key": 24494
                        },
                        {
                                "title": "黄南",
                                "value": 24495,
                                "key": 24495
                        },
                        {
                                "title": "果洛",
                                "value": 24496,
                                "key": 24496
                        }
                ]
        },
        {
                "title": "山东",
                "value": 25000,
                "key": 25000,
                "children": [
                        {
                                "title": "济南",
                                "value": 25196,
                                "key": 25196
                        },
                        {
                                "title": "济宁",
                                "value": 25197,
                                "key": 25197
                        },
                        {
                                "title": "聊城",
                                "value": 25199,
                                "key": 25199
                        },
                        {
                                "title": "德州",
                                "value": 25200,
                                "key": 25200
                        },
                        {
                                "title": "临沂",
                                "value": 25201,
                                "key": 25201
                        },
                        {
                                "title": "青岛",
                                "value": 25202,
                                "key": 25202
                        },
                        {
                                "title": "日照",
                                "value": 25203,
                                "key": 25203
                        },
                        {
                                "title": "潍坊",
                                "value": 25204,
                                "key": 25204
                        },
                        {
                                "title": "淄博",
                                "value": 25207,
                                "key": 25207
                        },
                        {
                                "title": "泰安",
                                "value": 25208,
                                "key": 25208
                        },
                        {
                                "title": "威海",
                                "value": 25218,
                                "key": 25218
                        },
                        {
                                "title": "烟台",
                                "value": 25219,
                                "key": 25219
                        },
                        {
                                "title": "东营",
                                "value": 25220,
                                "key": 25220
                        },
                        {
                                "title": "枣庄",
                                "value": 25221,
                                "key": 25221
                        },
                        {
                                "title": "菏泽",
                                "value": 25222,
                                "key": 25222
                        },
                        {
                                "title": "滨州",
                                "value": 25223,
                                "key": 25223
                        }
                ]
        },
        {
                "title": "山西",
                "value": 26000,
                "key": 26000,
                "children": [
                        {
                                "title": "晋城",
                                "value": 26205,
                                "key": 26205
                        },
                        {
                                "title": "晋中",
                                "value": 26206,
                                "key": 26206
                        },
                        {
                                "title": "长治",
                                "value": 26209,
                                "key": 26209
                        },
                        {
                                "title": "吕梁",
                                "value": 26210,
                                "key": 26210
                        },
                        {
                                "title": "临汾",
                                "value": 26211,
                                "key": 26211
                        },
                        {
                                "title": "忻州",
                                "value": 26212,
                                "key": 26212
                        },
                        {
                                "title": "朔州",
                                "value": 26213,
                                "key": 26213
                        },
                        {
                                "title": "太原",
                                "value": 26214,
                                "key": 26214
                        },
                        {
                                "title": "阳泉",
                                "value": 26215,
                                "key": 26215
                        },
                        {
                                "title": "运城",
                                "value": 26216,
                                "key": 26216
                        },
                        {
                                "title": "大同",
                                "value": 26217,
                                "key": 26217
                        }
                ]
        },
        {
                "title": "陕西",
                "value": 27000,
                "key": 27000,
                "children": [
                        {
                                "title": "宝鸡",
                                "value": 27239,
                                "key": 27239
                        },
                        {
                                "title": "安康",
                                "value": 27240,
                                "key": 27240
                        },
                        {
                                "title": "商洛",
                                "value": 27241,
                                "key": 27241
                        },
                        {
                                "title": "铜川",
                                "value": 27242,
                                "key": 27242
                        },
                        {
                                "title": "渭南",
                                "value": 27243,
                                "key": 27243
                        },
                        {
                                "title": "西安",
                                "value": 27244,
                                "key": 27244
                        },
                        {
                                "title": "咸阳",
                                "value": 27245,
                                "key": 27245
                        },
                        {
                                "title": "延安",
                                "value": 27246,
                                "key": 27246
                        },
                        {
                                "title": "汉中",
                                "value": 27248,
                                "key": 27248
                        },
                        {
                                "title": "榆林",
                                "value": 27249,
                                "key": 27249
                        }
                ]
        },
        {
                "title": "四川",
                "value": 28000,
                "key": 28000,
                "children": [
                        {
                                "title": "广安",
                                "value": 28224,
                                "key": 28224
                        },
                        {
                                "title": "广元",
                                "value": 28225,
                                "key": 28225
                        },
                        {
                                "title": "成都",
                                "value": 28226,
                                "key": 28226
                        },
                        {
                                "title": "眉山",
                                "value": 28227,
                                "key": 28227
                        },
                        {
                                "title": "凉山",
                                "value": 28228,
                                "key": 28228
                        },
                        {
                                "title": "绵阳",
                                "value": 28229,
                                "key": 28229
                        },
                        {
                                "title": "攀枝花",
                                "value": 28230,
                                "key": 28230
                        },
                        {
                                "title": "南充",
                                "value": 28231,
                                "key": 28231
                        },
                        {
                                "title": "德阳",
                                "value": 28232,
                                "key": 28232
                        },
                        {
                                "title": "乐山",
                                "value": 28233,
                                "key": 28233
                        },
                        {
                                "title": "泸州",
                                "value": 28234,
                                "key": 28234
                        },
                        {
                                "title": "内江",
                                "value": 28235,
                                "key": 28235
                        },
                        {
                                "title": "甘孜",
                                "value": 28236,
                                "key": 28236
                        },
                        {
                                "title": "遂宁",
                                "value": 28237,
                                "key": 28237
                        },
                        {
                                "title": "资阳",
                                "value": 28238,
                                "key": 28238
                        },
                        {
                                "title": "巴中",
                                "value": 28247,
                                "key": 28247
                        },
                        {
                                "title": "达州",
                                "value": 28250,
                                "key": 28250
                        },
                        {
                                "title": "雅安",
                                "value": 28251,
                                "key": 28251
                        },
                        {
                                "title": "阿坝",
                                "value": 28252,
                                "key": 28252
                        },
                        {
                                "title": "自贡",
                                "value": 28253,
                                "key": 28253
                        },
                        {
                                "title": "宜宾",
                                "value": 28254,
                                "key": 28254
                        }
                ]
        },
        {
                "title": "西藏",
                "value": 29000,
                "key": 29000,
                "children": [
                        {
                                "title": "那曲",
                                "value": 29268,
                                "key": 29268
                        },
                        {
                                "title": "拉萨",
                                "value": 29269,
                                "key": 29269
                        },
                        {
                                "title": "林芝",
                                "value": 29270,
                                "key": 29270
                        },
                        {
                                "title": "日喀则",
                                "value": 29271,
                                "key": 29271
                        },
                        {
                                "title": "昌都",
                                "value": 29480,
                                "key": 29480
                        },
                        {
                                "title": "山南",
                                "value": 29497,
                                "key": 29497
                        },
                        {
                                "title": "阿里",
                                "value": 29498,
                                "key": 29498
                        }
                ]
        },
        {
                "title": "新疆",
                "value": 30000,
                "key": 30000,
                "children": [
                        {
                                "title": "哈密",
                                "value": 30179,
                                "key": 30179
                        },
                        {
                                "title": "博尔塔拉",
                                "value": 30180,
                                "key": 30180
                        },
                        {
                                "title": "昌吉",
                                "value": 30181,
                                "key": 30181
                        },
                        {
                                "title": "阿勒泰",
                                "value": 30182,
                                "key": 30182
                        },
                        {
                                "title": "喀什",
                                "value": 30183,
                                "key": 30183
                        },
                        {
                                "title": "克拉玛依",
                                "value": 30184,
                                "key": 30184
                        },
                        {
                                "title": "阿克苏",
                                "value": 30185,
                                "key": 30185
                        },
                        {
                                "title": "克孜勒苏柯尔克孜",
                                "value": 30186,
                                "key": 30186
                        },
                        {
                                "title": "石河子",
                                "value": 30187,
                                "key": 30187
                        },
                        {
                                "title": "塔城",
                                "value": 30188,
                                "key": 30188
                        },
                        {
                                "title": "五家渠",
                                "value": 30189,
                                "key": 30189
                        },
                        {
                                "title": "吐鲁番",
                                "value": 30190,
                                "key": 30190
                        },
                        {
                                "title": "巴音郭楞",
                                "value": 30191,
                                "key": 30191
                        },
                        {
                                "title": "乌鲁木齐",
                                "value": 30192,
                                "key": 30192
                        },
                        {
                                "title": "伊犁",
                                "value": 30193,
                                "key": 30193
                        },
                        {
                                "title": "和田",
                                "value": 30195,
                                "key": 30195
                        },
                        {
                                "title": "阿拉尔",
                                "value": 30499,
                                "key": 30499
                        },
                        {
                                "title": "图木舒克",
                                "value": 30500,
                                "key": 30500
                        },
                        {
                                "title": "北屯",
                                "value": 30522,
                                "key": 30522
                        },
                        {
                                "title": "双河",
                                "value": 30523,
                                "key": 30523
                        },
                        {
                                "title": "可克达拉",
                                "value": 30524,
                                "key": 30524
                        },
                        {
                                "title": "昆玉",
                                "value": 30525,
                                "key": 30525
                        },
                        {
                                "title": "胡杨河",
                                "value": 30526,
                                "key": 30526
                        },
                        {
                                "title": "铁门关",
                                "value": 30527,
                                "key": 30527
                        }
                ]
        },
        {
                "title": "云南",
                "value": 31000,
                "key": 31000,
                "children": [
                        {
                                "title": "楚雄",
                                "value": 31283,
                                "key": 31283
                        },
                        {
                                "title": "昆明",
                                "value": 31284,
                                "key": 31284
                        },
                        {
                                "title": "丽江",
                                "value": 31285,
                                "key": 31285
                        },
                        {
                                "title": "德宏",
                                "value": 31286,
                                "key": 31286
                        },
                        {
                                "title": "临沧",
                                "value": 31287,
                                "key": 31287
                        },
                        {
                                "title": "曲靖",
                                "value": 31288,
                                "key": 31288
                        },
                        {
                                "title": "保山",
                                "value": 31289,
                                "key": 31289
                        },
                        {
                                "title": "普洱",
                                "value": 31290,
                                "key": 31290
                        },
                        {
                                "title": "文山",
                                "value": 31291,
                                "key": 31291
                        },
                        {
                                "title": "大理",
                                "value": 31292,
                                "key": 31292
                        },
                        {
                                "title": "红河",
                                "value": 31293,
                                "key": 31293
                        },
                        {
                                "title": "昭通",
                                "value": 31294,
                                "key": 31294
                        },
                        {
                                "title": "玉溪",
                                "value": 31295,
                                "key": 31295
                        },
                        {
                                "title": "怒江",
                                "value": 31481,
                                "key": 31481
                        },
                        {
                                "title": "迪庆",
                                "value": 31482,
                                "key": 31482
                        },
                        {
                                "title": "西双版纳",
                                "value": 31483,
                                "key": 31483
                        }
                ]
        },
        {
                "title": "浙江",
                "value": 32000,
                "key": 32000,
                "children": [
                        {
                                "title": "金华",
                                "value": 32272,
                                "key": 32272
                        },
                        {
                                "title": "嘉兴",
                                "value": 32273,
                                "key": 32273
                        },
                        {
                                "title": "衢州",
                                "value": 32274,
                                "key": 32274
                        },
                        {
                                "title": "丽水",
                                "value": 32275,
                                "key": 32275
                        },
                        {
                                "title": "宁波",
                                "value": 32276,
                                "key": 32276
                        },
                        {
                                "title": "绍兴",
                                "value": 32277,
                                "key": 32277
                        },
                        {
                                "title": "温州",
                                "value": 32278,
                                "key": 32278
                        },
                        {
                                "title": "台州",
                                "value": 32279,
                                "key": 32279
                        },
                        {
                                "title": "杭州",
                                "value": 32280,
                                "key": 32280
                        },
                        {
                                "title": "舟山",
                                "value": 32281,
                                "key": 32281
                        },
                        {
                                "title": "湖州",
                                "value": 32282,
                                "key": 32282
                        }
                ]
        },
        {
                "title": "重庆",
                "value": 33000,
                "key": 33000,
                "children": [
                        {
                                "title": "重庆",
                                "value": 33000,
                                "key": 33000
                        }
                ]
        },
        {
                "title": "香港",
                "value": 34000,
                "key": 34000,
                "children": [
                        {
                                "title": "香港",
                                "value": 34000,
                                "key": 34000
                        }
                ]
        },
        {
                "title": "台湾",
                "value": 35000,
                "key": 35000,
                "children": [
                        {
                                "title": "台北",
                                "value": 35501,
                                "key": 35501
                        },
                        {
                                "title": "高雄",
                                "value": 35502,
                                "key": 35502
                        },
                        {
                                "title": "新北",
                                "value": 35503,
                                "key": 35503
                        },
                        {
                                "title": "台中",
                                "value": 35504,
                                "key": 35504
                        },
                        {
                                "title": "台南",
                                "value": 35505,
                                "key": 35505
                        },
                        {
                                "title": "桃园",
                                "value": 35506,
                                "key": 35506
                        },
                        {
                                "title": "基隆",
                                "value": 35507,
                                "key": 35507
                        },
                        {
                                "title": "新竹",
                                "value": 35510,
                                "key": 35510
                        },
                        {
                                "title": "嘉义",
                                "value": 35516,
                                "key": 35516
                        },
                        {
                                "title": "宜兰",
                                "value": 35511,
                                "key": 35511
                        },
                        {
                                "title": "苗栗",
                                "value": 35512,
                                "key": 35512
                        },
                        {
                                "title": "彰化",
                                "value": 35513,
                                "key": 35513
                        },
                        {
                                "title": "云林",
                                "value": 35514,
                                "key": 35514
                        },
                        {
                                "title": "南投",
                                "value": 35515,
                                "key": 35515
                        },
                        {
                                "title": "屏东",
                                "value": 35517,
                                "key": 35517
                        },
                        {
                                "title": "台东",
                                "value": 35518,
                                "key": 35518
                        },
                        {
                                "title": "花莲",
                                "value": 35519,
                                "key": 35519
                        },
                        {
                                "title": "澎湖",
                                "value": 35520,
                                "key": 35520
                        }
                ]
        },
        {
                "title": "澳门",
                "value": 36000,
                "key": 36000,
                "children": [
                        {
                                "title": "澳门",
                                "value": 36000,
                                "key": 36000
                        }
                ]
        }
]

export default baiduRegion
